<template>
  <div class="admin-bug-reports custom-scroll-bar-2">
    <vue-element-loading :active="isLoading" spinner="bar-fade-scale" />
    <div class="admin-bug-reports__toolbar">
      <select v-model="category" class="admin-bug-reports__select" @change="reload">
        <option value="">Tất cả loại lỗi</option>
        <option v-for="item in categories" :key="item.value" :value="item.value">
          {{ item.label }}
        </option>
      </select>
      <input
        ref="dateRange"
        type="text"
        class="admin-bug-reports__daterange"
        readonly
      />
    </div>

    <div class="admin-bug-reports__table-wrap">
      <table class="ml-member-tbl">
        <thead>
          <tr>
            <th class="text-400-semibold ml-table-cell w_min_80">ID</th>
            <th class="text-400-semibold ml-table-cell">Người gửi</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Loại lỗi</th>
            <th class="text-400-semibold ml-table-cell">Mô tả</th>
            <th class="text-400-semibold ml-table-cell w_min_160">File</th>
            <th class="text-400-semibold ml-table-cell w_min_160">Thời gian</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!items.length && !isLoading">
            <td colspan="6" class="text-center admin-bug-reports__empty">
              Không có báo cáo trong khoảng đã chọn.
            </td>
          </tr>
          <tr v-for="row in items" :key="row.id">
            <td class="text-400-medium ml-table-cell">{{ row.id }}</td>
            <td class="text-400-medium ml-table-cell">
              {{ row.user && row.user.fullname ? row.user.fullname : "-" }}
            </td>
            <td class="text-400-medium ml-table-cell">{{ row.category_label }}</td>
            <td class="text-400-medium ml-table-cell">
              <div class="admin-bug-reports__desc">{{ row.description }}</div>
            </td>
            <td class="ml-table-cell">
              <div class="admin-bug-reports__files">
                <a
                  v-for="file in row.files || []"
                  :key="file.id"
                  :href="file.url"
                  target="_blank"
                  rel="noopener"
                  class="admin-bug-reports__file"
                >
                  <img v-if="file.kind === 'image'" :src="file.url" alt="" />
                  <span v-else class="material-icons">videocam</span>
                </a>
              </div>
            </td>
            <td class="text-400-medium ml-table-cell">{{ formatDate(row.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination-template
      v-if="pagination.lastPage > 1"
      class="admin-bug-reports__pagination"
      :params="pagination"
      @change-params="changePage"
    />
  </div>
</template>

<script>
import moment from "moment";
import BugReportService from "../../../../store/services/BugReportService";
import PaginationTemplate from "../../../Components/PaginationTemplate";
import { BUG_REPORT_CATEGORIES, AGENCY_SUPPORT_CATEGORIES } from "../../../../helper/bugReport";

function loadStyle(href) {
  if (document.querySelector(`link[href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const el = document.createElement("script");
    el.src = src;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error("Không tải được daterangepicker"));
    document.body.appendChild(el);
  });
}

export default {
  name: "AdminBugReports",
  components: { PaginationTemplate },
  data() {
    return {
      categories: [...BUG_REPORT_CATEGORIES, ...AGENCY_SUPPORT_CATEGORIES],
      category: "",
      from: moment().subtract(6, "days").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
      items: [],
      isLoading: false,
      pagination: { page: 1, perPage: 20, lastPage: 1, total: 0 },
    };
  },
  async mounted() {
    await this.initDateRange();
    this.fetchList();
  },
  beforeDestroy() {
    const input = this.$refs.dateRange;
    const $ = window.jQuery;
    if (input && $ && $(input).data("daterangepicker")) {
      $(input).data("daterangepicker").remove();
    }
  },
  methods: {
    async initDateRange() {
      loadStyle("/vendor/daterangepicker/daterangepicker.css");
      window.moment = moment;
      await loadScript("/vendor/daterangepicker/daterangepicker.min.js");
      const $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.daterangepicker) return;
      const start = moment(this.from);
      const end = moment(this.to);
      $(this.$refs.dateRange).daterangepicker(
        {
          startDate: start,
          endDate: end,
          maxDate: moment(),
          opens: "left",
          alwaysShowCalendars: true,
          locale: {
            format: "DD/MM/YYYY",
            separator: " - ",
            applyLabel: "Áp dụng",
            cancelLabel: "Hủy",
            fromLabel: "Từ",
            toLabel: "Đến",
            customRangeLabel: "Tùy chọn",
            daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
            monthNames: [
              "Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6",
              "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12",
            ],
            firstDay: 1,
          },
          ranges: {
            "Hôm nay": [moment(), moment()],
            "7 ngày": [moment().subtract(6, "days"), moment()],
            "30 ngày": [moment().subtract(29, "days"), moment()],
            "Tháng này": [moment().startOf("month"), moment()],
          },
        },
        (from, to) => {
          this.from = from.format("YYYY-MM-DD");
          this.to = to.format("YYYY-MM-DD");
          this.pagination.page = 1;
          this.fetchList();
        },
      );
    },
    reload() {
      this.pagination.page = 1;
      this.fetchList();
    },
    changePage(params) {
      this.pagination.page = params.page;
      this.fetchList();
    },
    formatDate(value) {
      if (!value) return "-";
      return moment(value).format("HH:mm DD/MM/YYYY");
    },
    async fetchList() {
      this.isLoading = true;
      try {
        const res = await BugReportService.adminList({
          category: this.category || undefined,
          from: this.from,
          to: this.to,
          page: this.pagination.page,
          per_page: this.pagination.perPage,
        });
        if (!res || res.status === false) {
          this.items = [];
          if (res && res.message) {
            this.$notify({ type: "error", text: res.message });
          }
          return;
        }
        const payload = res.data || {};
        this.items = payload.items || [];
        const paging = payload.pagination || {};
        this.pagination.lastPage = paging.last_page || 1;
        this.pagination.total = paging.total || this.items.length;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin-bug-reports {
  padding: 16px;
}
.admin-bug-reports__toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}
.admin-bug-reports__select,
.admin-bug-reports__daterange {
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 220px;
  background: #fff;
}
.admin-bug-reports__table-wrap {
  overflow: auto;
}
.admin-bug-reports__empty {
  padding: 24px 0;
}
.admin-bug-reports__desc {
  white-space: pre-wrap;
  max-width: 420px;
}
.admin-bug-reports__files {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.admin-bug-reports__file {
  display: inline-flex;
  width: 48px;
  height: 36px;
  border-radius: 6px;
  overflow: hidden;
  background: #f1f5f9;
  align-items: center;
  justify-content: center;
  color: #334155;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.admin-bug-reports__pagination {
  margin-top: 16px;
}
</style>
